module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-white@2x-05eed8d9.png";